import React from 'react';
import { Box, Group, Text } from '@mantine/core';
import { Dropzone, type FileRejection } from '@mantine/dropzone';
import classes from './FileDropzone.module.css';
import type { FileDropzoneProps } from './types';
import { Icon } from '../Icon';

/**
 * Presentational inline FileDropzone overlay used inside ChatInputSimple and AttachModal.
 * Side effects (uploads, store updates) are handled by the parent via callbacks.
 */
export const FileDropzone: React.FC<FileDropzoneProps> = ({
  onDropValid,
  onDropRejected,
  disabled,
  isUploading,
  // The minimal inline overlay does not render limits/errors/actions visually,
  // but we keep props for API compatibility.
  maxFilesLeft: _maxFilesLeft,
  errorMessage: _errorMessage,
  onCloseOverlay: _onCloseOverlay,
  accept,
  maxSize,
  className,
}) => {
  const handleDrop = (files: File[]) => onDropValid(files);
  const handleReject = (rejections: FileRejection[]) => onDropRejected?.(rejections);

  return (
    <Box className={`${classes.overlay} ${className || ''}`} role="region" aria-label="File drop area">
      <Dropzone
        className={classes.dropzone}
        onDrop={handleDrop}
        onReject={handleReject}
        accept={accept}
        maxSize={maxSize}
        disabled={disabled || isUploading}
      >
        <Group align="center" justify="center" gap={10} className={classes.centerRow}>
          <Icon name="attach" size={18} style={{ color: '#2C60C4' }} />
          <Text className={classes.textPrimary}>Drop Your Files Here</Text>
        </Group>
      </Dropzone>
    </Box>
  );
};

export default FileDropzone;
